var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "15", height: "15", viewBox: "0 0 15 15" }, props),
    React.createElement("path", { className: styles["a"] || "a", d: "M7.5 12.871A5.372 5.372 0 1 1 12.871 7.5 5.378 5.378 0 0 1 7.5 12.871zm0-8.005A2.634 2.634 0 1 0 10.133 7.5 2.637 2.637 0 0 0 7.5 4.866z" }),
    React.createElement("path", { className: styles["a"] || "a", d: "M9.337 2.576H5.663l.548-2.579H8.79zM5.318 2.721l-2.6 2.6L1.282 3.11l1.824-1.824zM2.579 5.663v3.674L0 8.789V6.21zM2.718 9.681l2.6 2.6-2.211 1.436-1.824-1.824zM5.663 12.421h3.674L8.789 15H6.206zM9.68 12.279l2.6-2.6 1.436 2.211-1.824 1.824zM12.421 9.337V5.663L15 6.211V8.79zM12.278 5.32l-2.6-2.6 2.211-1.436 1.824 1.824z" })
  );
});